import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  ClearImmunizationErrors,
  ImmunizationActionToggleLoading,
  ImmunizationActionTypes,
  ImmunizationCreated,
  ImmunizationOnServerCreated,
  ImmunizationOnServerDeleted,
  ImmunizationOnServerUpdated,
  ImmunizationPageLoaded,
  ImmunizationPageRequested,
  ImmunizationPageToggleLoading,
  ImmunizationUpdated,
  ThrowImmunizationError,
  ImmunizationDeleted,
} from '../_actions/immunization.actions';
import { ImmunizationsService } from '../_services/immunization.service';

@Injectable()
export class ImmunizationsEffects {
  showPageLoadingDistpatcher = new ImmunizationPageToggleLoading({ isLoading: true });
  hideLoadingDistpatcher = new ImmunizationPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ImmunizationActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ImmunizationActionToggleLoading({ isLoading: false });

  @Effect()
  loadImmunizationsPage$ = this.actions$.pipe(
    ofType<ImmunizationPageRequested>(ImmunizationActionTypes.ImmunizationPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      return this.immunizationsService.findImmunizations(payload.entityId).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.errors) {
            this.store.dispatch(new ThrowImmunizationError({ error: res }));
          } else {
            this.store.dispatch(new ClearImmunizationErrors());
            this.store.dispatch(this.hideLoadingDistpatcher);
            const olives = [];
            this.store.dispatch(new ClearImmunizationErrors());
            for (let i = 0; res.entry.length > i; i++) {
              olives.push(res.entry[i].resource);
            }
            return new ImmunizationPageLoaded({
              immunizations: olives,
              totalCount: res.total,
            });
          }
        }),
      );
    }),
  );
  @Effect()
  updateImmunization$ = this.actions$.pipe(
    ofType<ImmunizationOnServerUpdated>(ImmunizationActionTypes.ImmunizationOnServerUpdated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.immunizationsService
        .updateImmunization(payload.immunization, payload.entityId)
        .pipe(
          catchError((error) => {
            return of({ error });
          }),
          map((res: any) => {
            if (res && res.errors) {
              return new ThrowImmunizationError({ error: res });
            } else {
              this.store.dispatch(this.hideActionLoadingDistpatcher);
              this.store.dispatch(new ClearImmunizationErrors());
              return new ImmunizationUpdated({
                immunization: {
                  id: payload.immunization.id,
                  changes: payload.immunization,
                },
              });
            }
          }),
        );
    }),
  );

  @Effect()
  createImmunization$ = this.actions$.pipe(
    ofType<ImmunizationOnServerCreated>(ImmunizationActionTypes.ImmunizationOnServerCreated),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.immunizationsService
        .createImmunization(payload.immunization, payload.entityId)
        .pipe(
          catchError((error) => {
            return of(error);
          }),
          map((res) => {
            if (res && res.errors) {
              return new ThrowImmunizationError({ error: res });
            } else {
              this.store.dispatch(this.hideActionLoadingDistpatcher);
              this.store.dispatch(new ClearImmunizationErrors());
              return new ImmunizationCreated({ immunization: payload.immunization });
            }
          }),
        );
    }),
  );

  @Effect()
  deleteImmunization$ = this.actions$.pipe(
    ofType<ImmunizationOnServerDeleted>(ImmunizationActionTypes.ImmunizationOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.immunizationsService.deleteImmunization(payload.immunization_id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map(() => {
          this.store.dispatch(this.hideActionLoadingDistpatcher);
          return new ImmunizationDeleted({ immunization_id: payload.immunization_id });
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private immunizationsService: ImmunizationsService,
    private store: Store<AppState>,
  ) {}
}
